import type { Tenant } from '../lib/database.types';
import type { SiteStatus } from '../lib/siteStatus';

/**
 * Page affichée côté client quand le site d'un resto est suspendu ou désactivé
 * (cf. sql/31_site_status.sql). Message clair + branding léger du resto.
 */
export default function MaintenancePage({ tenant, status }: { tenant: Tenant; status: SiteStatus }) {
  const color = tenant.primary_color || tenant.brand_color || '#C0392B';
  const definitif = status === 'disabled';
  return (
    <main
      className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center"
      style={{ background: `${color}0D` }}
    >
      <div className="text-6xl">🛠️</div>
      <h1 className="text-2xl font-extrabold" style={{ color }}>
        {tenant.name}
      </h1>
      <div
        className="max-w-md rounded-2xl border bg-white p-6 shadow-sm"
        style={{ borderColor: `${color}33` }}
      >
        <p className="text-lg font-bold">Site en maintenance</p>
        <p className="mt-2 text-slate-600">
          {definitif
            ? 'Ce site de commande est actuellement indisponible.'
            : 'Ce site de commande est momentanément indisponible.'}
        </p>
        <p className="mt-2 text-sm text-slate-500">
          Merci de vous rapprocher de votre prestataire / informaticien pour le réactiver.
        </p>
      </div>
      <p className="text-xs text-slate-400">YumLink · Lil &amp; Co Click &amp; Collect</p>
    </main>
  );
}
